/* eslint-disable multiline-ternary */
import React, { memo, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useGlobalState } from '../providers/GlobalState'
import { IolType } from '../types/graphql'
import { motion } from 'framer-motion'
import {
  animationAppTransitions,
  animationAppVariants
} from '../component/Helpers/pageAnimation'
import SimulationsButton from '../component/SimulationsButton'
import { KelmanSlider } from '@phaco3d/kelman'
import { useEditMode } from '../providers/EditMode'
import IolTypeSlug from '../component/IOL/IolType-slug'

interface ParamTypes {
  iolId: string
}

const IolPage: React.FC = () => {
  const [activeIol, setActiveIol] = useState<IolType | null | undefined>()
  const [options, setOptions] = useState<
    { name: string; url: string; active?: boolean }[]
  >([])
  const [url, setUrl] = useState<string>('thumb')
  const { editMode } = useEditMode()
  const { iolId } = useParams<ParamTypes>()
  const { iolTypes } = useGlobalState()

  const handleChange = (url: string) => {
    setUrl(url)
  }

  useEffect(() => {
    if (iolTypes) {
      setActiveIol(iolTypes.find(x => x?.slug === iolId))
    }
  }, [iolId, iolTypes])

  useEffect(() => {
    if (activeIol) {
      setOptions([
        {
          name: 'Informativo',
          url: 'thumb',
          active: true
        },
        {
          name: 'Simulação',
          url: 'simulation',
          active: !!activeIol.simulation
        }
      ])
    }
  }, [activeIol])

  const Simulation = () => {
    if (activeIol?.thumb && activeIol.simulation && url === 'simulation') {
      return (
        <KelmanSlider
          leftImage={activeIol?.simulation.before || ''}
          rightImage={activeIol?.simulation.after || ''}
          vertical
        />
      )
    } else {
      return (
        <img
          src={activeIol?.thumb}
          alt={activeIol?.name}
          style={{
            zIndex: 10,
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            width: '100%',
            height: '100%'
          }}
        />
      )
    }
  }

  const Page = (): JSX.Element => {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={animationAppVariants}
        transition={animationAppTransitions}
        style={{
          position: 'relative',
          background: 'linear-gradient(180deg, #666666 0%, #666666 143.29%)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          margin: 'auto',
          pointerEvents: editMode ? 'none' : 'initial'
        }}
      >
        {Simulation()}
      </motion.div>
    )
  }

  return (
    <>
      <Page />
      {editMode && <IolTypeSlug />}
      {activeIol && options.length > 1 && (
        <SimulationsButton
          handleScenarioChange={handleChange}
          options={options}
          activeUrl={url}
        />
      )}
    </>
  )
}

export default memo(IolPage)
